import { render, staticRenderFns } from "./OldPackageReport.vue?vue&type=template&id=9c5246ae&scoped=true"
import script from "./OldPackageReport.vue?vue&type=script&lang=js"
export * from "./OldPackageReport.vue?vue&type=script&lang=js"
import style0 from "./OldPackageReport.vue?vue&type=style&index=0&id=9c5246ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5246ae",
  null
  
)

export default component.exports